/*
 * Single source of truth for every raw colour value used by the aisle config builder and preview.
 *
 * The builder grid and the preview table must stay visually consistent: a Bag column painted in the
 * builder has to read as the same colour in the rack preview and in the preview legend. Keeping the
 * swatches here means a recolour is a one-file change instead of three files drifting apart.
 *
 * Meridian 4 (the version this package is pinned to) exposes no colour token module, so these are
 * literal hex values. When the package moves to Meridian 6, this file is the only place that has to
 * be swapped over to design tokens.
 */

// Base swatches. Nothing outside this file should reference a hex value directly.
const SWATCH = {
    GREEN: {backgroundColor: '#e6f4ea', borderColor: '#34a853', color: '#1e4620'},
    BLUE: {backgroundColor: '#e8f0fe', borderColor: '#4285f4', color: '#174ea6'},
    AMBER: {backgroundColor: '#fff4e5', borderColor: '#e77600', color: '#8a4b08'},
    GREY: {backgroundColor: '#f5f7f8', borderColor: '#d9e2e8', color: '#6b7a85'},
    SLATE: {backgroundColor: '#f1f3f4', borderColor: '#d5dbdb', color: '#5f6368'}
};

// Rack zone semantics: builder column tiles, preview cells, and the preview legend.
export const RACK_ZONE_COLORS = {
    BAG: SWATCH.GREEN,
    OV: SWATCH.BLUE,
    FLEX: SWATCH.AMBER,
    ABSENT: SWATCH.GREY,
    PILLAR: SWATCH.SLATE
};

// Match-status semantics, kept deliberately separate from the rack zones even though the swatches
// currently coincide, so that recolouring a rack zone cannot silently restyle the match chip.
export const STATUS_COLORS = {
    MATCHED: SWATCH.GREEN,
    UNMATCHED: SWATCH.AMBER
};

// Preview table cells paint fill and text only; their border comes from the shared cell style.
export const getZoneFill = ({backgroundColor, color}) => ({backgroundColor, color});



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/aisleconfig/AisleConfigColors.js